import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// CSS
import './styles.css';

const Container = styled.div`
  ${({ borderBottom }) =>
    borderBottom &&
    css`
      border-bottom: 1px solid var(--secondary-gray);
      margin-left: -20px;
      margin-right: -20px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 16px;
    `}

  ${({ lastItem }) =>
    lastItem &&
    css`
      margin-bottom: 0 !important;
    `}
`;

const RedeliveryText = styled.span`
  color: gray;
  font-style: italic;
  font-weight: normal;
`;

export default class SidePanelListItem extends Component {
  render() {
    const {
      className, borderBottom, lastItem, hasReDelivery,
    } = this.props;

    return (
      <Container
        borderBottom={borderBottom}
        lastItem={lastItem}
        className={`SidePanelListItem ${className || ''}`}
      >
        <div className="SidePanelListItem__Label">
          {this.props.title} {hasReDelivery ? <RedeliveryText>(Redespacho)</RedeliveryText> : null}
        </div>
        <div className="SidePanelListItem__Desc">{this.props.children}</div>
      </Container>
    );
  }
}

SidePanelListItem.propTypes = {
  title: PropTypes.string.isRequired,
};
